module.exports = __webpack_public_path__ + "img/mobile scanner stand10.b5948bec.jpg";